import { PaneLayoutInteractionType } from '@eventbrite/eds-modal';
import {
    getFooterHeight,
    getIsOrderSummaryBiggerThanScreen,
    getOrderSummaryHeight,
} from './rebrand';

export const getPaneInteractionType = () => {
    const orderSummaryHeight = getOrderSummaryHeight() || 0;
    const footerHeight = getFooterHeight() || 0;

    const isOrderSummaryBiggerThanScreen = getIsOrderSummaryBiggerThanScreen(
        orderSummaryHeight,
        footerHeight,
    );

    return isOrderSummaryBiggerThanScreen
        ? PaneLayoutInteractionType.asCollapsible
        : PaneLayoutInteractionType.asModal;
};
